// SECTION 1 · 상단 4분할 요약 타일 — 소속 · 파트너십(LMPA) · 주력 카테고리 · 활동 채널.
//
// 타일 = 라벨 + 값(대표님 원본 문법). 실데이터 철칙:
//   · 소속 = label 있으면 label 메인, 없고 isLeferi면 "Leferi 소속" 폴백, 둘 다 아니면 "—".
//   · 파트너십 = lmpaParticipant true만 "LMPA 참여"(블루), 그 외(false/null)는 "—"(회색·미참여).
//   · 카테고리/활동채널 = 비면 "—". 텍스트 3배 길이도 word-break로 잘리지 않음.
import type { ProfileData } from '../../creatorsApi'
import { PLATFORM_LABEL } from '../overview/format'

interface Props {
  isLeferi: boolean
  label?: string
  lmpaParticipant?: boolean
  categories: string[]
  activeChannels: ProfileData['activeChannels']
}

function Tile({
  caption,
  value,
  accent,
  muted,
}: {
  caption: string
  value: string
  accent?: boolean
  muted?: boolean
}) {
  return (
    <div className="min-w-0 bg-surface-base p-[16px_20px]">
      <div className="font-text text-[11px] text-fg-3">{caption}</div>
      <div
        className={[
          'mt-1 break-keep font-display text-[16px] font-bold leading-[1.3]',
          accent ? 'text-brand-blue' : muted ? 'text-ink-400' : 'text-ink-800',
        ].join(' ')}
      >
        {value}
      </div>
    </div>
  )
}

export function IdentityTiles({
  isLeferi,
  label,
  lmpaParticipant,
  categories,
  activeChannels,
}: Props) {
  const affiliation = label?.trim() || (isLeferi ? 'Leferi 소속' : '—')
  const categoryValue = categories.length > 0 ? categories.join(' · ') : '—'
  const channelValue =
    activeChannels.length > 0 ? activeChannels.map((p) => PLATFORM_LABEL[p]).join(' · ') : '—'

  return (
    <div className="grid grid-cols-2 gap-px border border-line-hairline bg-line-hairline sm:grid-cols-4">
      <Tile caption="소속" value={affiliation} />
      <Tile
        caption="파트너십(LMPA)"
        value={lmpaParticipant ? 'LMPA 참여' : '—'}
        accent={lmpaParticipant === true}
        muted={!lmpaParticipant}
      />
      <Tile caption="주력 카테고리" value={categoryValue} />
      <Tile caption="활동 채널" value={channelValue} />
    </div>
  )
}
